
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class VatWarning extends Vue {
    @Prop() id: string;
}
